import { SignalCellularConnectedNoInternet0BarOutlined } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";
import { GlobalAppIssue } from "./global-app-issue";
import IssueTitle from "./issue-title";

export const NoInternetIssue = () => (
  <GlobalAppIssue icon={<SignalCellularConnectedNoInternet0BarOutlined />}>
    <IssueTitle>
      <FormattedMessage
        id="globalAppIssue.noInternet.title"
        defaultMessage="No internet."
      />
    </IssueTitle>
    <FormattedMessage
      id="globalAppIssue.noInternet.description"
      defaultMessage="Your device has little to no internet. Expect interrupted functionality of the application until this improves."
    />
  </GlobalAppIssue>
);
